import classNames from 'classnames';
import { IconClose } from '../QuirkIcons';
import { FieldValuesType, FormValueType } from '../../hooks/useFormValues';
import { FormInputParams } from '../../model/form';
// eslint-disable-next-line css-modules/no-unused-class
import commonStyles from './FormFields.module.css';
import styles from './SimpleCSSColorInput.module.css';

export type SimpleCSSColor = `#${string}` | 'transparent';

export type SimpleCSSColorInputParams<T, K extends keyof T> = Omit<FormInputParams<T, K>, 'field' | 'type' | 'step'> & {
	field: FieldValuesType<SimpleCSSColor | undefined>;
	colors: SimpleCSSColor[];
};
export function SimpleCSSColorInput<T, K extends keyof T>({
	setValues,
	id,
	field,
	nogap,
	label,
	onChange,
	colors
}: SimpleCSSColorInputParams<T, K>) {
	const onClick = (color: SimpleCSSColor) => {
		if (color !== field.value) {
			setValues({ [id]: color } as FormValueType<T>);
			onChange?.(color);
		}
	};
	return (
		<div className={styles.ColorInput} style={{ marginBottom: nogap ? '10px' : '30px' }}>
			<label className={classNames(commonStyles.label, styles.label)}>{label}</label>
			{colors.map(color => (
				<div
					key={color}
					className={classNames(
						styles.color,
						color === 'transparent' ? styles.transparent : '',
						field?.value === color ? styles.selected : ''
					)}
					style={{ backgroundColor: color }}
					onClick={() => onClick(color)}
				>
					{color === 'transparent' && <IconClose size={'large'} />}
				</div>
			))}
		</div>
	);
}
